import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { MdPrint, MdDelete } from 'react-icons/lib/md';
import _ from 'lodash';
import '../../css/unitOfMeasure.css';
import { withAuth } from '../../actions';
import { modalStyle } from '../../constants';
import { FieldLike, SCOPE_TABS, Tabs } from './utils';
import { getProjectType } from '../../utils';
import { MdOpenInNew } from 'react-icons/lib/md';
import { largeModalStyle } from '../../constants';
import ComplexityFactor from './ComplexityFactor';

//import Select from 'react-select';
//import { connect } from 'react-redux';
//import { fetch_lkp_LeedCertification } from '../../actions/additional_actions';

Modal.setAppElement('#root');

class ReadonlyInfo extends Component {
	constructor (props) {
		super(props);

		this.state = {
			activeTab: 'scope',
			isOpen: false,
			loader: false,
			info: {},
			wsEditable: false,
			webScope: this.props.info.webScope,
			toEdit: null,
			toAdd: null,
			showErr: false,
			errText: '',
			confirmBtn: false,
			showProjectTypeUnitOfMeasureForm: false,
			projectTypesPbState: [],
			projectTypesPbStateUnmodified: [],
			projectTypesSelected: [],
			showComplexityForm: false
		}

		this.setActiveTab = this.setActiveTab.bind(this);
		this.editWebScope = this.editWebScope.bind(this);
		this.handlePMReqAEServ = this.handlePMReqAEServ.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
		this.handleChangeWs = this.handleChangeWs.bind(this);
		this.saveWs = this.saveWs.bind(this);
		this.cancelWs = this.cancelWs.bind(this);

		this.showDelete = this.showDelete.bind(this);
		this.deleteFms = this.deleteFms.bind(this);
		this.onDone = this.onDone.bind(this);
		this.showAdd = this.showAdd.bind(this);
		this.handleChangeFms = this.handleChangeFms.bind(this);
		this.addFms = this.addFms.bind(this);
		this.postFms = this.postFms.bind(this);
		this.getLeadFms = this.getLeadFms.bind(this);
		this.getFmsObj = this.getFmsObj.bind(this);
		this.onModalClose = this.onModalClose.bind(this);
		this.onModalReset = this.onModalReset.bind(this);
		this.onModalSave = this.onModalSave.bind(this);
		this.onModalOpen = this.onModalOpen.bind(this);
		this.onAfterModalOpen = this.onAfterModalOpen.bind(this);
		this.onUomCheckChange = this.onUomCheckChange.bind(this);
		this.onProjectTypeChecked = this.onProjectTypeChecked.bind(this);
		this.onProjectTypeUomChanged = this.onProjectTypeUomChanged.bind(this);
		this.onProjectTypeUomCostChanged = this.onProjectTypeUomCostChanged.bind(this);
		this.onComplexityDone = this.onComplexityDone.bind(this);
	}

	componentDidMount() {
		this.infoFields = [
			'phaseName', 'projectType', 'priority', 'designContractType', 'constructionContractType', 'phase',
			'projectId', 'projectDescription', 'subPhase', 'designGroup', 'designBy', 'cmBoro', 'cmBoard',
			'infraType', 'benchmarkStatus', 'isReadOnlySubPhase', 'constructionFiscalYear', 'designFiscalYear',
			'programTypeId', 'previousFiscalYear', 'critical',
		];

		this.setState((_state, _props) => ({
			info: _.pick(this.props.info, this.infoFields)
		}));
	}

	shouldComponentUpdate(_nextProps, _nextState) {
		return true;
	}

	UNSAFE_componentWillReceiveProps(nextProps){
		this.SetUomDefaultValuesFromProps(nextProps);
		this.SetUomActualValuesFromProps(nextProps);
	}

	SetUomDefaultValuesFromProps(nextProps) {
		if (nextProps.projectTypesPb.length > 0 && nextProps.projectTypesPb !== this.props.projectTypesPb) {
			nextProps.projectTypesPb.forEach(pt => pt.isSelected = false);
			nextProps.projectTypesPb.forEach(pt => { pt.yesNoAnswer = ''; pt.uomCost = '';});

			this.setState((_state, _props) => ({
				projectTypesPbState: nextProps.projectTypesPb,
				projectTypesPbStateUnmodified: JSON.parse(JSON.stringify(nextProps.projectTypesPb))
			}));

			//console.log('set uom defaults');
		}

		this.SetUomValuesForModal()
	}

	SetUomActualValuesFromProps(nextProps) {
		if (nextProps.projectTypesSelected && nextProps.projectTypesSelected.length > 0 && nextProps.projectTypesSelected !== this.props.projectTypesSelected) {

			this.setState((_state, _props) => ({
				projectTypesSelected: nextProps.projectTypesSelected
			}));
		}

		this.SetUomValuesForModal()
	}

	SetUomValuesForModal() {
		var projecTypesPbCurrent = this.state.projectTypesPbState;
		var projectTypesSelectedCurrent = this.state.projectTypesSelected;

		if (!projecTypesPbCurrent || projecTypesPbCurrent.length < 1 || !projectTypesSelectedCurrent || projectTypesSelectedCurrent.length < 1) {
			//console.log('actual values fail early');
			return;
		}

		projecTypesPbCurrent.forEach(pt => { pt.isSelected = false; pt.uomValue = ''; pt.uomCost = '';});

		projectTypesSelectedCurrent.forEach(e => {
			var currentIndex = projecTypesPbCurrent.findIndex(pt => pt.id === e.projectTypeId);
			if (currentIndex > -1) {
				projecTypesPbCurrent[currentIndex].isSelected = true;
				projecTypesPbCurrent[currentIndex].isDisabled = false;
				projecTypesPbCurrent[currentIndex].uomValue = e.uomValue === null ? '' : e.uomValue;
				projecTypesPbCurrent[currentIndex].uomCost = e.uomCost === null ? '' : e.uomCost;

				if (e.projectTypeId === 1) {
					projecTypesPbCurrent.forEach(p => {
						if (p.id !== 1) {
							p.isDisabled = true;
						}
					});
				} else if (e.projectTypeId === 40) {
					projecTypesPbCurrent.forEach( p => {
						if (p.id !== 40) {
							p.isDisabled = true;
						}
					});
				} else {
					projecTypesPbCurrent.forEach( p => {
						if (p.id === 1 || p.id === 40) {
							p.isDisabled = true;
						}
					});
				}
			}
		});

		this.setState((_state, _props) => ({
			projectTypesPbState: projecTypesPbCurrent,
			projectTypesPbStateUnmodified: JSON.parse(JSON.stringify(projecTypesPbCurrent))
		}));

		//console.log('set uom actual values');
	}

	toggleModal() {
		const { projectId } = this.props.info;
		let url = `projects/${projectId}/statusreport`;

		let method = 'get';
		let responseType = 'arraybuffer';
		this.setState ({loader:true});
		withAuth(
			{ method, url, responseType },
			(response) => {
				this.setState ({loader:false});
				var data = response.data;
				var contentType = 'application/pdf';
				var blob = new Blob([data], { type: contentType });
				var downloadUrl= window.URL.createObjectURL(blob);
				window.open(downloadUrl,'_blank');
			},
			this.errorHandler
		)
	}

	onUomCheckChange() {
		alert('test');
	}

	onModalSave() {
		var GetSelectedUoms = function(projectTypesList) {
			var projectTypesSelected = projectTypesList.filter(x => x.isSelected);
			return projectTypesSelected;
		}

		const info = { ...this.state.info, projectTypesSelected: GetSelectedUoms(this.state.projectTypesPbState)}

		this.setState((_state, _props) => ({
			info,
			projectTypesPbStateUnmodified: this.state.projectTypesPbState
		}));

		this.props.onUomSubmit(info);

		this.setState({ showProjectTypeUnitOfMeasureForm: false });
	}

	onModalReset() {
		if (this.state.projectTypesPbStateUnmodified) {
			var originalPojectTypeUoms = JSON.parse(JSON.stringify(this.state.projectTypesPbStateUnmodified));
			this.setState({ projectTypesPbState: originalPojectTypeUoms });
		}
	}

	onModalClose() {
		this.onModalReset();
		this.setState({ showProjectTypeUnitOfMeasureForm: false });
	}

	onModalOpen() {
		this.setState({ showProjectTypeUnitOfMeasureForm: true });
	}

	onComplexityModalOpen() {
		this.setState({ showComplexityForm: true });
	}

	onComplexityModalReset() {

	}

	onComplexityModalClose() {
		this.onComplexityModalReset();
		this.setState({ showComplexityForm: false });
	}

	onAfterModalOpen() {
		const info = { ...this.state.info, projectTypesSelected: this.state.projectTypesPbState };

		//console.log('after modal open');
	}

	renderLoading() {
		if (!this.state.loader) return null;
		return <div className="loader" />
	}

	setActiveTab (tab) {
		this.setState({activeTab: tab});
	}

	editWebScope(_tab) {
		this.setState({ wsEditable: true });
	}

	cancelWs() {
		this.setState({ wsEditable: false });
	}

	renderScope (text) {
		return (
			<div className="controls">
				<div className="value paraish">
					{ text
						? text.split(/(?:\r\n|\r|\n)/g).map((s, i) => <span key={i}>{s}</span>)
						: null }
				</div>
			</div>
		);
	}

	renderWebScope(text) {
		return (
			<div className="controls">
				<div className="value paraish">
					{text
						? text.split(/(?:\r\n|\r|\n)/g).map((s, i) => <span key={i}>{s}</span>)
						: null}
				</div>
			</div>
		);
	}

	handleChangeWs(_text) {
		return (e) => {
			this.setState({ webScope: e.target.value });
		};
	}

	renderEditableWebScope(text) {
		return (
			<div className="controls">
				<div className="value paraish">
					<div>
						<span onClick={this.cancelWs} className="btn-cancel" >Cancel</span>
						<button onClick={this.saveWs} className="btn-save">Save</button>
					</div>
					<textarea rows="3" // name="comment"  
						value={this.state.webScope !== undefined ? this.state.webScope : text}
						onChange={this.handleChangeWs(text)}></textarea>
				</div>
			</div>
		);
	}

	saveWs(e) {
		//original code:
		//this.state.info.webScope = this.state.webScope;
		//const info = this.state.info;

		const newInfo = {
			...this.props.info,
			webScope: this.state.webScope,
		};

		e.preventDefault();

		this.props.saveWs(newInfo);
		this.cancelWs();
	}

	handlePMReqAEServ(_e) {
		//
	}

	getListProjectTypesSelected(projectTypesSelected) {
		const { projectTypes } = this.props;
		let str = '';
		if (!projectTypesSelected)
			return '';

		switch (projectTypesSelected.length) {
			case 0:
				return '';
			case 1:
				return getProjectType(projectTypes, projectTypesSelected[0].projectTypeId);
			default:
				projectTypesSelected.forEach(function(pts) {
					if (projectTypes === undefined)
						return '';
					var ptf = projectTypes.find(function(pt) {
						return pts.projectTypeId === pt.id;
					});
					if (ptf !== undefined)
						if (str === '')
							str = ptf.projectType;
						else
							str = str.concat(', ', ptf.projectType);
				});
				return str.length < 93 ? str : (str.substring(0,90) + '...');
		}
	}

	getProgramType(programTypes, programTypeId) {
		if (programTypes === undefined)
			return null;

		let programType = null;

		for (let pt of programTypes) {
			if (pt.id === programTypeId) {
				programType = pt.programType;
				break;
			}
		}

		return programType;
	}

	getCritical(criticalvalue){
		if(criticalvalue != null){
			if(criticalvalue === 1 )
				return 'Yes';
			else
				return 'No';
		}
	}

	showDelete(item, index) {
		this.setState({ toEdit: {fmsId: item, index: index} });
	}

	showAdd(toAdd) {
		this.setState({ toAdd });
	}

	onDone (_shouldFetch) {
		this.setState({ toEdit: null, toAdd: null, showErr: false, errText: '', confirmBtn: false});
	}

	onComplexityDone() {
		this.setState({ showComplexityForm: false});
	}

	postFms(e) {
		e.preventDefault();

		let url = '/projects/fmsId'; let method = 'post';

		const obj = this.getFmsObj();
		var cloneOfInfo = JSON.parse(JSON.stringify(this.props.info));
		cloneOfInfo.secondaryFmsS.unshift(obj.fMSRefId);

		withAuth(
			{ method, url, data: obj },
			() => {
				this.onDone(true);
				this.props.saveInfo(cloneOfInfo);
			},
			() => { this.setState({ showErr: true, errText: 'Not allowed to add duplicate FMS ID.', confirmBtn: false }); }
		);
	}

	getLeadFms() {
		var leadFmsId = null;
		if (this.props.info.projectFMS !== undefined) {
			var leadFms = this.props.info.projectFMS.find(f => { return f.leadFMSId === true });
			if (leadFms !== undefined)
				leadFmsId = leadFms.fmsRefId;
		}
		return leadFmsId;
	}

	getFmsObj() {
		const projFmsObjAdd = {
			projectRefId: this.props.info.projectId,
			fMSRefId: this.state.toAdd
		};
		return projFmsObjAdd;
	}

	addFms(e) {
		e.preventDefault();
		this.setState({ showErr: false, errText: '', confirmBtn: false });

		var leadFmsId = this.getLeadFms();
		if (this.state.toAdd === leadFmsId) {
			this.setState({ showErr: true, errText: 'This FMS ID is a Lead FMS ID in current project. Please add different FMS ID.' });
			return;
		}

		else if (this.state.toAdd === null || this.state.toAdd === undefined || this.state.toAdd === '' || !/\S/.test(this.state.toAdd) ) {
			this.setState({ showErr: true, errText: 'Please enter valid FMS ID.' });
			return;
		}

		let url = `/projects/checkFms/${this.state.toAdd}`; let method = 'get';

		withAuth(
			{ method, url },
			(response) => {
				var data = response.data;

				if (data.length > 0) {
					var projL = _.filter(response.data, function (v) { return v.leadFMSId === true });

					// Display error: lead fmsId for projects
					if (projL.length > 0) {
						let projIdsLead = projL.map(a => a.projectRefId);
						this.setState({
							showErr: true, errText: `${this.state.toAdd} is a Lead FMS ID in the following projects: ${projIdsLead.join(', ')} .
             Please add different FMS ID.` });
						return;
					}
					else {
						// Display warning: existing fmsIds
						let projIdFms = data.map(a => a.projectRefId);
						if (projIdFms.includes(this.props.info.projectId))
							this.setState({showErr: true, errText: 'Not allowed to add duplicate FMS ID.'});
						else
							this.setState({ showErr: true, errText: `${this.state.toAdd} is an FMS ID in the following projects: ${projIdFms.join(', ')} .
            Are you sure you want to add this FMS ID?`, confirmBtn: true });
					}
				}
				else {
					let url = '/projects/fmsId'; let method = 'post';

					const obj = this.getFmsObj();
					var cloneOfInfo = JSON.parse(JSON.stringify(this.props.info));
					cloneOfInfo.secondaryFmsS.unshift(obj.fMSRefId);

					withAuth(
						{ method, url, data: obj },
						() => {
							this.onDone(true);
							this.props.saveInfo(cloneOfInfo);
						},
						() => { this.setState({ showErr: true, errText: 'Error has occured.', confirmBtn: false }); }
					);
				}
			},
			() => { this.setState({ showErr: true, errText: 'Error has occured.', confirmBtn: false }); }
		);
	}

	deleteFms(e) {
		e.preventDefault();

		let url, method;

		url = '/projects/fmsId';
		method = 'delete';
		const projFmsObj = {
			projectRefId: this.props.info.projectId,
			fMSRefId: this.state.toEdit.fmsId
		};

		var cloneOfInfo = JSON.parse(JSON.stringify(this.props.info));

		var index = this.state.toEdit.index;
		if (index > -1) {
			cloneOfInfo.secondaryFmsS.splice(index, 1);
		}

		withAuth(
			{ method, url, data: projFmsObj },
			() => {
				this.onDone(true);
				this.props.saveInfo(cloneOfInfo);
			},
			() => { this.setState({ showErr: true, errText: 'Error has occured.', confirmBtn: false }); }
		);
	}

	handleChangeFms (field) {
		return (e) => {
			this.setState({ [field]: e.target.value, showErr: false, errText: '', confirmBtn: false });
		}
	}

	renderModalDelete() {
		const { toEdit } = this.state;
		const isOpen = !(toEdit === null);

		return (
			<Modal
				isOpen={isOpen}
				style={modalStyle}
				contentLabel="Confirm Delete"
			>
				{toEdit &&
					<div className="alert-modal">
						<h1>Confirm</h1>

						<div className="modal-close"
							onClick={this.onDone}>
							<span className="close"></span>
						</div>

						<p>Are you sure you want to delete FMS ID <span id="fmsIdColor">{toEdit.fmsId}</span> ?</p>

						{this.state.showErr &&
							<div>
								<p className="color-orange">Error has occured. Please try again.</p>
							</div>
						}

						<div className="actions">
							<button className="alert-save" onClick={this.deleteFms}>Yes</button>
							<button className="alert-cancel" onClick={this.onDone}>No</button>
						</div>

					</div>}
			</Modal>
		);
	}

	renderModalAdd() {
		const isOpen = !(this.state.toAdd === null);
		return (
			<Modal
				isOpen={isOpen}
				style={modalStyle}
				contentLabel="Add"
			>
				<form className="modal-form blue-book-form">
					<h1>Add</h1>

					<div className="modal-close"
						onClick={this.onDone}>
						<span className="close"></span>
					</div>

					<div className="control">
						<label>Secondary FMS ID</label>
						<input type="text" name="toAdd"
							value={this.state.toAdd || ''}
							onChange={this.handleChangeFms('toAdd')}
						/>
						{this.state.showErr &&
							<div>
								<p className="color-orange">{this.state.errText}</p>
							</div>
						}
					</div>

					<div className="actions">
						{this.state.confirmBtn
							? <button className="alert-save" onClick={this.postFms}>Yes</button>
							: <button className="alert-save" onClick={this.addFms}>Save</button>}
						<button className="alert-cancel" onClick={this.onDone}>Cancel</button>
					</div>

				</form>
			</Modal>
		);
	}

	onProjectTypeChecked(projectType) {
		projectType.isSelected = !projectType.isSelected;
		var newPtList = JSON.parse(JSON.stringify(this.state.projectTypesPbState));   //deep copy
		var currentIndex = newPtList.findIndex(pt => pt.id === projectType.id);

		if (projectType.id === 1 || projectType.id === 40) {
			if (projectType.isSelected) { //when checkbox becomes checked
				newPtList.forEach(pt => pt.isSelected = false);
				newPtList.forEach(pt => pt.isDisabled = true);

				newPtList[currentIndex].isSelected = true;
				newPtList[currentIndex].isDisabled = false;
			} else { //when checkbox becomes un-checked
				newPtList[currentIndex].isSelected = false;
				newPtList[currentIndex].uomValue = '';
				newPtList.forEach(pt => pt.isDisabled = false);
			}
		} else {
			var newContructionIndex = newPtList.findIndex(pt => pt.id === 1);
			var majorRehabIndex = newPtList.findIndex(pt => pt.id === 40);

			if (projectType.isSelected) { //when checkbox becomes checked
				newPtList[currentIndex].isSelected = true;
				newPtList[currentIndex].isDisabled = false;

				newPtList[newContructionIndex].isDisabled = true;
				newPtList[majorRehabIndex].isDisabled = true;
			} else { //when checkbox becomes un-checked
				newPtList[currentIndex].isSelected = false;
				newPtList[currentIndex].uomValue = '';

				if (newPtList.filter(x => x.isSelected).length === 0) {
					newPtList[newContructionIndex].isDisabled = false;
					newPtList[majorRehabIndex].isDisabled = false;
				}
			}
		}

		this.setState((_state, _props) => ({
			projectTypesPbState: newPtList
		}));
		// this.setState({
		//     projectTypesPbState: newPtList
		// });
	}

	onProjectTypeUomChanged(projectTypeId, newUomValue) {
		var newPtList = JSON.parse(JSON.stringify(this.state.projectTypesPbState));   //deep copy
		var currentIndex = newPtList.findIndex(pt => pt.id === projectTypeId);

		newPtList[currentIndex].uomValue = parseFloat(newUomValue);

		// this.setState((state, props) => ({
		// 	projectTypesPbState: newPtList
		// }));

		this.setState({
			projectTypesPbState: newPtList
		});
	}

	onProjectTypeUomCostChanged(projectTypeId, newCostUomValue) {
		var newPtList = JSON.parse(JSON.stringify(this.state.projectTypesPbState));   //deep copy
		var currentIndex = newPtList.findIndex(pt => pt.id === projectTypeId);

		newPtList[currentIndex].uomCost = parseFloat(newCostUomValue);

		this.setState({
			projectTypesPbState: newPtList
		});

	}

	startComplexityForm () {
		this.setState({ toLeedForm: true })
	}

	renderComplexityForm () {
		return (
			<div>
				<ComplexityFactor
					projectId={this.props.info.projectId}
					onModalClose={this.onComplexityDone}
				/>
				<div className="modal-close" onClick={this.onComplexityDone}>
					<span className="close"></span>
				</div>
			</div>
		);
	}

	render() {  //ReadOnlyForm
		const { info, projectTypesSelected, programTypes, phaseName } = this.props; //projectTypesPb 
		//console.log("render read only form");
		const { activeTab } = this.state;

		var renderProjectType = function (projectType) {
			switch (projectType.id) {
				case 69:
					return <td colSpan="2" rowSpan="3">{projectType.projectType}</td>;
				case 73:
					return <td colSpan="2" rowSpan="5">{projectType.projectType}</td>;
				case 48:
				case 68:
				case 70:
				case 71:
				case 50:
				case 75:
					return null;
				default:
					return <td colSpan="2">{projectType.projectType}</td>;
			}
		};

		let {infraClass} = '';
		if(this.props.info.divisionName === 'Infrastructure')
			infraClass = 'col s12 m6 l3';
		else
			infraClass = 'col s12 l4';

		const pStyle = {
			cursor : 'pointer'
		}

		const tableHeaderStyle = {
			textAlign : 'center'
		}

		return (
			<div className="clearfix">
				<div className="col s12">
					<div className="project-flags">
						<div className="flag">
							<button onClick={this.toggleModal} className="padding-left-0">
								<strong>Status Report</strong>
								<span className="margin-left-075">
									<MdPrint size={20} color="#8492a6" />
								</span>
							</button>
							{this.renderLoading()}
						</div>
					</div>
				</div>

				<div className={infraClass}>
					<div className="boxed" id="overflY">
						{this.renderModalDelete()}
						{this.renderModalAdd()}

						<FieldLike label="FMS ID" value={this.getLeadFms()} />

						{this.props.canEditWebScope && (
							<button
								className="btn-save"
								id="addFmsBtn"
								onClick={() => this.showAdd()}
							>
								Add FMS ID
							</button>
						)}

						{!this.props.canEditWebScope ? (
							<FieldLike
								label="Secondary FMS IDs"
								value={
									this.props.info.secondaryFmsS &&
									this.props.info.secondaryFmsS.join(', ')
								}
							/>
						) : (
							<div className="controls">
								<span className="label">Secondary FMS IDs</span>
								{this.props.info &&
									this.props.info.secondaryFmsS &&
									this.props.info.secondaryFmsS.length > 0 &&
									this.props.info.secondaryFmsS.map((item, index) => (
										<span key={index} className="value">
											{item}
											<span
												className="float-right cursor-pointer"
												onClick={() => this.showDelete(item, index)}
											>
												<MdDelete size={18} color="#8492a6" />
											</span>
										</span>
									))}
							</div>
						)}

						<FieldLike label="Division" value={info.divisionName} />
						<FieldLike label="Program unit" value={info.unitName} />
						{
							<FieldLike
								label="Program Type"
								value={this.getProgramType(
									programTypes,
									info.programTypeId
								)}
							/>
						}
						{info.divisionName === 'Public Buildings' &&  <FieldLike label="Project Delivery Method" value={info.projectDeliveryMethod} />}

						<FieldLike label="Sponsor" value={info.sponsor} />
						<FieldLike label="Status" value={info.benchmarkStatus} />
					</div>
				</div>

				<div className={infraClass}>
					<div className="boxed" id="overflY">
						<FieldLike label="Current Phase" value={info.phase} />
						{info.phase == 'Design' && info.divisionName != "Infrastructure" && <FieldLike label="Subphase" value={phaseName} />}
						{(info.divisionName == "Infrastructure" || (info.divisionName == "Public Buildings" && info.phase != 'Design')) && <FieldLike label="Subphase" value={info.subPhase} />}
						{/* <FieldLike label="Project Type" value={this.getListProjectTypesSelected(projectTypesSelected)} /> */}
						{this.props.info.divisionName === 'Public Buildings' ?
							<div className="controls">
								<div id="clicky" onClick={() => this.onModalOpen()} style={pStyle}>
									<span className="label">
										Project Type <MdOpenInNew className="fa-Icon" />
									</span>
								</div>
								<span className="value">
									{this.getListProjectTypesSelected(projectTypesSelected)}
								</span>
							</div> :
							<FieldLike label="Project Type" value={this.getListProjectTypesSelected(projectTypesSelected)}/>
						}
						{this.props.info.divisionName === 'Public Buildings' ? <div className="controls" id="complexityLink">
							<div id="clicky" onClick={() => this.onComplexityModalOpen()} style={pStyle}>
								<span className="label">
									Project Complexity <MdOpenInNew className="fa-Icon" />
								</span>
							</div>
						</div> : null }
						<FieldLike label="Priority" value={info.priority} />
						<div className="controls padding-bottom-0">
							<span className="label underline">Contract Type:</span>
						</div>
						<FieldLike label="Design" value={info.designContractType} />
						<FieldLike
							label="Construction"
							value={info.constructionContractType}
						/>
					</div>
				</div>
				{info.divisionName === 'Infrastructure' ? (
					<div className={infraClass}>
						<div className="boxed4">
							<FieldLike label="Design By" value={info.designBy} />
							<FieldLike label="Design Group" value={info.designGroup} />
							{/* <FieldLike label="Infra Type" value={info.infraType} /> */}
							<FieldLike label="CM Boro" value={info.cmBoro} />
							<FieldLike
								label="Construction FY"
								value={info.constructionFiscalYear}
							/>
							<FieldLike label="Design FY" value={info.designFiscalYear} />
							<FieldLike
								label="Original FY"
								value={info.previousFiscalYear}
							/>

							{/* <FieldLike label="Critical" value={this.getCritical(info.critical)} />             */}
							{/* <FieldLike label="CM Board" value={info.cmBoard} /> */}
						</div>
					</div>
				) : null}
				<div className={infraClass}>
					<div className="boxed">
						<Tabs
							tabs={SCOPE_TABS}
							current={activeTab}
							setTab={this.setActiveTab}
							editWs={this.editWebScope}
							canEditWs={this.props.canEditWebScope}
						/>
						{activeTab === 'scope' && this.renderScope(info.scope)}

						{activeTab === 'webScope' && this.state.wsEditable === false
							? this.renderWebScope(info.webScope)
							: activeTab === 'webScope' &&
								this.state.wsEditable === true &&
								this.props.canEditWebScope === true
								? this.renderEditableWebScope(info.webScope)
								: null}
					</div>
				</div>

				<Modal
					isOpen={this.state.showProjectTypeUnitOfMeasureForm}
					style={largeModalStyle}
					onAfterOpen={() => this.onAfterModalOpen()}
					contentLabel="Project type unit of measure form"
				>
					{/* <h1>Project Type Units of Measurement</h1> */}
					<form className="modal-form">
						<div className="table-wrap" id="uoms">
							<table className="uomTable">
								<thead>
									<tr>
										<th
											className="uomTable"
											colSpan="3"
											rowSpan="2"
											align="Center"
											fontground-color="white"
											style={tableHeaderStyle}
										>
											Project Type
										</th>
										<th className="uomTable" colSpan="3" align="Center" style={tableHeaderStyle}>
											Unit of Measurement
										</th>
										<th
											align="Left"
											rowSpan="2"
											style={tableHeaderStyle}
										>
											Description
										</th>
									</tr>
									<tr>
										<th style={tableHeaderStyle}>Unit</th>
										<th style={tableHeaderStyle}>Quantity</th>
										<th style={tableHeaderStyle}>Construction Cost ($)</th>
									</tr>
								</thead>
								<tbody>
									{
										this.state.projectTypesPbState && this.state.projectTypesPbState.map((pt, index) => {
											//projectTypesPb && projectTypesPb.map((pt, index) => {
											return <tr key={index}>
												<td>  <input type="checkbox" name="requiredTask"
													onChange={() => this.onProjectTypeChecked(pt)}
													disabled={pt.isDisabled}
													checked={pt.isSelected}
												/></td>

												{/* {pt.id !== 1 && pt.id !== 40 ? 
                                    renderParentProjectType(pt)
                                     :
                                        null
                                      }  */}


												{/* pt.id === 1 || pt.id === 40 ? 
                                        <td colSpan="2">{pt.projectType}</td> : */}
												{ renderProjectType(pt) }

												<td>{pt.unitOfMeasure}</td>
												<td className="disabledUnit">
													<input className="uomTextBox" type="number" name="uomValue" min="0.01" step="0.01" autoComplete="off"
														disabled={!pt.isSelected} value={pt.uomValue} onChange={e=>this.onProjectTypeUomChanged(pt.id, e.target.value)}/>
												</td>

												<td className="disabledUnit">
													<input className="uomTextBox" type="number" name="uomCost" min="0.01" step="0.01" autoComplete="off"
														disabled={!pt.isSelected} value={pt.uomCost} onChange={e=>this.onProjectTypeUomCostChanged(pt.id, e.target.value)}/>
												</td>

												{pt.id === 73 ?
													<td rowSpan="5"><div dangerouslySetInnerHTML={{ __html: pt.description }} /></td> :
													pt.id === 70 || pt.id === 71 || pt.id === 50 || pt.id === 75 ? null :
														<td><div dangerouslySetInnerHTML={{ __html: pt.description }} /></td>
												}
											</tr>
										})
									}
								</tbody>
							</table>

						</div>

						<div className="modal-close">
							<span className="close" onClick={() => this.onModalClose()}></span>
						</div>

						<div className="actions">
							<button type="button" className="btn-update btn-update-custom" onClick={() => this.onModalReset()}>UNDO</button>
							<button type="button" className="btn-update btn-update-custom" onClick={() => this.onModalSave()}>SAVE</button>
						</div>
					</form>
				</Modal>

				<Modal
					isOpen={this.state.showComplexityForm}
					style={largeModalStyle}
					contentLabel="Project complexity form"
				>

					{this.state.showComplexityForm && this.renderComplexityForm()}
				</Modal>
			</div>
		);
	}
}

ReadonlyInfo.propTypes = {
	info: PropTypes.object.isRequired,
	setCurrentTab: PropTypes.func.isRequired,
	setPMReqAEServ: PropTypes.func.isRequired
};

export default ReadonlyInfo;